import { BeekLogo, DeviceSizes } from 'beek-design-system';
import { BeekSessionStatus } from 'src/utils/user';
import { Button } from '@beek/design-system';
import { useTranslations } from 'next-intl';
import AccountMenu from 'src/components/Common/NavBar/AccountMenu';
import Link from 'next/link';
import styled from 'styled-components';

type NavBarProps = {
  sessionStatus: BeekSessionStatus;
};

const NavBarContainer = styled.nav`
  z-index: 10;
  display: flex;
  position: sticky;
  width: 100%;
  top: 0;
  background-color: rgba(255, 255, 255, 1);
  flex-direction: row;
  padding: 1rem 2rem;
  align-items: center;
  gap: 1rem;
`;

const MenuContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const TypographyContainer = styled.div`
  display: none;
  @media ${DeviceSizes.tablet} {
    display: inherit;
  }
`;

const NavBar = ({ sessionStatus }: NavBarProps): JSX.Element => {
  const t = useTranslations('landing');
  return (
    <NavBarContainer>
      <BeekLogo variant="small" marginRight="1rem" />
      <Link href="/html_sitemap/audiolibros_a.html">
        <a>{t('navBar.audiobooks')}</a>
      </Link>
      <Link href="/listas">
        <a>{t('navBar.articles')}</a>
      </Link>
      <MenuContainer>
        {sessionStatus === BeekSessionStatus.LoggedOut ? (
          <>
            <TypographyContainer>{`${t('navBar.signIn')}`}</TypographyContainer>
            <Link href={'/login'} passHref>
              <Button>{t('navBar.logIn')}</Button>
            </Link>
          </>
        ) : (
          <AccountMenu />
        )}
      </MenuContainer>
    </NavBarContainer>
  );
};

export default NavBar;
